import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39576ca6")

_pushScopeId("data-v-39576ca6")
const _hoisted_1 = { class: "general-information" }
const _hoisted_2 = { class: "attribute-line" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Name", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "attribute-line" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Event", -1)
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "attribute-line" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Vehicle Types", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "attribute-line" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Day Labels", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "attribute-line" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "label" }, "OSL", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "attribute-line" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Routing Service Version", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "attribute-line" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Comments", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 1,
  class: "edit"
}
const _hoisted_25 = { class: "attribute-line" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Vehicle Types", -1)
const _hoisted_27 = { ref: "vehicleTypesRef" }
const _hoisted_28 = { class: "attribute-line" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Day Labels", -1)
const _hoisted_30 = { ref: "dayLabelsRef" }
const _hoisted_31 = { class: "attribute-line" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "label" }, "OSL", -1)
const _hoisted_33 = { ref: "oslRef" }
const _hoisted_34 = { class: "attribute-line" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Routing Service Version", -1)
const _hoisted_36 = { ref: "routingServiceVersionRef" }
const _hoisted_37 = { class: "attribute-line" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Comments", -1)
const _hoisted_39 = {
  key: 0,
  class: "error"
}
const _hoisted_40 = { class: "attribute-line2" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Active")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Not active")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Delete overlay", -1)
const _hoisted_48 = { slot: "content" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" You're going to delete permanently this overlay.")
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Could you confirm ? ")
const _hoisted_52 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Delete restricted areas")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Delete custom roads")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Delete")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_input = _resolveComponent("calcite-input")
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_checkbox = _resolveComponent("calcite-checkbox")
  const _component_calcite_modal = _resolveComponent("calcite-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.overlay?.Name), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.overlay?.Event), 1)
    ]),
    (!_ctx.isEditable)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.overlay?.VehicleTypes), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.overlay?.DayLabels), 1)
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("span", _hoisted_17, _toDisplayString(_ctx.overlay?.OperationalServiceLevels), 1)
          ]),
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("span", _hoisted_20, _toDisplayString(_ctx.overlay?.RoutingServiceVersion), 1)
          ]),
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.overlay?.Comments), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEditable)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode("select", _hoisted_27, null, 512)
          ]),
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode("select", _hoisted_30, null, 512)
          ]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("select", _hoisted_33, null, 512)
          ]),
          _createVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("select", _hoisted_36, null, 512)
          ]),
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(_component_calcite_input, {
              value: _ctx.overlay?.Comments,
              ref: "commentsRef",
              type: "textarea"
            }, null, 8, ["value"])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode("span", null, _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_40, [
      (_ctx.overlay?.Active == 1 && _ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 0,
            "icon-end": "check",
            onClick: _cache[1] || (_cache[1] = $event => {_ctx.overlay.Active = 0; _ctx.isOverlayActive()}),
            color: "blue",
            style: {"margin-right":"10px"},
            disabled: !_ctx.isClickable,
            class: {'hidden': _ctx.isEditable}
          }, {
            default: _withId(() => [
              _hoisted_41
            ]),
            _: 1
          }, 8, ["disabled", "class"]))
        : _createCommentVNode("", true),
      (_ctx.overlay?.Active == 0 && _ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 1,
            "icon-end": "x",
            onClick: _cache[2] || (_cache[2] = $event => {_ctx.overlay.Active = 1; _ctx.isOverlayActive()}),
            color: "light",
            style: {"margin-right":"10px"},
            disabled: !_ctx.isClickable
          }, {
            default: _withId(() => [
              _hoisted_42
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (!_ctx.isEditable && _ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 2,
            class: "delete",
            "icon-end": "pencil",
            onClick: _cache[3] || (_cache[3] = $event => {_ctx.initMultiselect(); _ctx.isEditable = !_ctx.isEditable}),
            color: "blue",
            style: {"margin-right":"10px"},
            disabled: !_ctx.isClickable
          }, {
            default: _withId(() => [
              _hoisted_43
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.isEditable && _ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 3,
            class: "delete",
            "icon-end": "check",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.editInformations())),
            color: "blue",
            style: {"margin-right":"10px"}
          }, {
            default: _withId(() => [
              _hoisted_44
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isEditable && _ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 4,
            class: "delete",
            "icon-end": "x",
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.isEditable = !_ctx.isEditable)),
            color: "grey",
            style: {"margin-right":"10px"}
          }, {
            default: _withId(() => [
              _hoisted_45
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isEditor)
        ? (_openBlock(), _createBlock(_component_calcite_button, {
            key: 5,
            class: ["delete", {'hidden': _ctx.isEditable}],
            "icon-end": "trash",
            onClick: _cache[6] || (_cache[6] = $event => {_ctx.showModal = true; _ctx.isClickable = !_ctx.isClickable}),
            color: "red",
            style: {"margin-right":"10px"},
            disabled: !_ctx.isClickable
          }, {
            default: _withId(() => [
              _hoisted_46
            ]),
            _: 1
          }, 8, ["disabled", "class"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_calcite_modal, {
          key: 2,
          width: "s",
          active: "",
          "disable-close-button": "",
          "disable-outside-close": ""
        }, {
          default: _withId(() => [
            _hoisted_47,
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53,
              _createVNode(_component_calcite_checkbox, {
                scale: "s",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.deleteRestricted = !_ctx.deleteRestricted)),
                disabled: _ctx.restrictedAreasSize.size == 0
              }, {
                default: _withId(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["disabled"]),
              _hoisted_55,
              _createVNode(_component_calcite_checkbox, {
                scale: "s",
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.deleteCustom = !_ctx.deleteCustom)),
                disabled: _ctx.customRoadsSize.size == 0
              }, {
                default: _withId(() => [
                  _hoisted_56
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createVNode(_component_calcite_button, {
              slot: "back",
              color: "light",
              onClick: _cache[9] || (_cache[9] = $event => {_ctx.showModal = false; _ctx.isClickable = !_ctx.isClickable})
            }, {
              default: _withId(() => [
                _hoisted_57
              ]),
              _: 1
            }),
            _createVNode(_component_calcite_button, {
              slot: "primary",
              color: "red",
              onClick: _cache[10] || (_cache[10] = $event => {_ctx.deleteOverlay(); _ctx.showModal = false})
            }, {
              default: _withId(() => [
                _hoisted_58
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})